/**
 *
 */
class SmoothScroll{

    /**
     *
     * @param options
     */
    constructor(Bulb){

        Utils.debug('Construct SmoothScroll');

        let self = this;
        this.bulb = Bulb;
        this.initItems();

        this.isScrolling = false;
        this.scrollingWay = 'UP';
        this.lastScrollTop = $(window).scrollTop();

        this.newY = -1;

        // Cas spécial dans le cas de consultation dans elementor on vire le scroll avec inertie
        if(Utils.inIframe()){
            this.itemsScrollable = false;
            this.containerScrollable.css({
                'position' : 'static'
            });
            $('footer').css({
                'position' : 'static'
            });
        }


        this.containerScrollable.on('SmoothPagesTransition:buildNextPage', () => {
            this.resizeContainer();
            this.scrollParallaxResize();
            this.initItems();
        });

        if(this.containerScrollable){
            this.resizeContainer();
        }

        if(this.itemsParallaxable){
            this.scrollParallaxResize();
        }

    }


    initItems(){
        this.containerScrollable = $(this.bulb.options.containerScrollable);
        this.itemsReveable = $(this.bulb.options.itemsReveable);
        this.itemsParallaxable = $(this.bulb.options.itemsParallaxable);
        this.itemsScrollable = $(this.bulb.options.itemsScrollable);
        Utils.debug(this.itemsReveable);
    }


    /**
     *
     */
    resizeContainer() {
        if(!this.bulb.lowVersion){
            $('body').css({
                height: this.containerScrollable.outerHeight()
            });
        }
    }


    /**
     * Lorsqu'un item apparait sur le viewport
     */
    scrollRevealHandler(elt){


        var element = $(elt);
        if(!element.hasClass('visible')){
            element.trigger({
                type: 'reveal',
                way: this.scrollingWay,
                lowVersion: this.bulb.lowVersion,
                device: this.bulb.device
            });
        }
        element.addClass('visible visibleEffect');
    }

    /**
     * Lorsqu'un item dispparait sur le viewport
     */
    scrollDisapearHandler(elt){
        var element = $(elt);

        if(element.hasClass('visible')) {
            element.trigger({
                type: 'unreveal',
                way: this.scrollingWay
            });
        }


        element.removeClass('visible');
    }


    scrolling(){

        var self = this;

        this.windowHeight = $(window).height();
        this.windowScrollTop = $(window).scrollTop();


        // on stoque le sens du scroll au besoin
        if(this.windowScrollTop != this.lastScrollTop) {
            this.isScrolling = true;
            if (this.windowScrollTop > this.lastScrollTop) {
                this.scrollingWay = 'UP';
            } else {
                this.scrollingWay = 'DOWN';
            }
        } else {
            this.isScrolling = false;
        }

        this.lastScrollTop = this.windowScrollTop;


        if (this.itemsReveable) {
            this.revealableActions();
        }

        if (this.itemsScrollable) {
            this.scrollItems();
        }

        if(this.bulb.lowVersion){
            let vpHeight = Verge.viewportH();
            $('.section__home, .homeEffect').css('height', vpHeight);
        }

        requestAnimationFrame(function(){self.scrolling()});
    }


    /**
     * permet d
     */
    revealableActions(){

        var revealableElements = $(this.bulb.options.itemsReveable);

        /*
        if(this.bulb.lowVersion){
            revealableElements = $(this.bulb.options.itemsReveable + ',' + this.bulb.options.itemsScrollable);
        }
        */

        var self = this;
        revealableElements.each(function(){
            var element = $(this);
            if(Verge.inViewport(element)){
                self.scrollRevealHandler(this);
            } else {
                self.scrollDisapearHandler(this);
            }
        })
    }


    scrollItems(){
        let self = this;
        let destY = this.windowScrollTop;
        this.resizeContainer();
        if(this.scrollingWay == 'UP'){
            if(destY < 10) destY = 0;
        }


        if(!self.bulb.lowVersion){

            let parallaxableResetY = Verge.viewportH() / 2;
            if(this.bulb.device.isMd){
                parallaxableResetY = Verge.viewportH() / 4;
            }

            this.itemsScrollable.each(function(){

                let element = $(this);

                let currentY = 0;
                if(element.get(0)._gsTransform != undefined){
                    currentY = -element.get(0)._gsTransform['y'];
                }


                let decalY = 0;
                let level = 0;
                let destYItem = destY;
                let offsetY = 0;

                // on va va un decalage de bloc, plus le bloc est bas plus le décallage est grand
                if(element.attr('data-level')){
                    level = Number(element.attr('data-level'));
                }

                // on va pondérer le décallage en fonction de la taille de l'écran, plus lécran est petit plus le décallage est petit
                level = (Verge.viewportW() / 1920) * level;
                if(element.attr('data-level') && level < 100) level = 100;
                let viewportOffset = element.get(0).getBoundingClientRect();
                let yFromWP = Math.floor(viewportOffset.top) - parallaxableResetY;
                let yPercentWP = yFromWP * 100 / self.windowHeight;
                offsetY = Math.floor(yPercentWP * level / 100);

                if(offsetY > 0){
                    destYItem = destYItem - offsetY;
                }

                //pas possible d'aller plus haut que le top pour les elements avec la classe parallaxable__fixeToTop
                if(element.hasClass('parallaxable__fixeToTop') && (self.bulb.device.isLg || self.bulb.device.isXl || element.hasClass('homeBackground')) ){
                    if( destY  > $(this).data('top') ){
                        destYItem = destY - ( destY - $(this).data('top'));
                    }
                }



                let newY = Math.round((currentY + ((destYItem - currentY) * 0.1))*1000) / 1000;
                TweenMax.set(element, {y: - (newY), force3D: true});


            });

        }

        $('body').trigger({
            type: 'scrolling',
            newY: destY,
            way: this.scrollingWay,
            device: this.bulb.device,
            bulb: this.bulb
        });
}


    /**
     * Action pour scroller le site (smooth)
     */
    scrollableActions(){
        var destY = this.windowScrollTop;
        var currentY = -Utils.getTranslateY(this.containerScrollable);

        this.resizeContainer();

        if(this.scrollingWay == 'UP'){
            if(destY < 10) destY = 0;
        }

        if (Math.round(this.newY) != destY) {

            Utils.debug('Ajuste scroll')

            this.newY = Math.round((currentY + ((destY - currentY) * 0.1))*100) / 100;
            TweenMax.set(this.containerScrollable, {y: -this.newY})
            //TweenMax.set('.fixed', {y: this.newY});

            $('body').trigger({
                type: 'scrolling',
                newY: this.newY,
                way: this.scrollingWay
            });
        }

    }

    /**
     *
     */
    scrollParallaxResize(){


        Utils.debug('smoothscroll::scrollParallaxResize');


        //var currentY = -Utils.getTranslateY(this.containerScrollable);

        $(this.bulb.options.itemsParallaxable).each(function() {
            var element = $(this);
            var transform = element.css('transform');
            element.css({
                transform: ''
            });

            element.attr('data-top', element.offset().top - $(window).scrollTop());
            //element.attr('data-bottom', element.offset().top + element.outerHeight());
            //element.attr('data-start', element.offset().top - $(window).height());
            //element.attr('data-stop', element.offset().top + element.outerHeight());

            element.css({
                transform: element.css('transform')
            });
        });
    }


    /**
     * Action pour gérer les effets paralaxes sur les items
     */
    parallaxableActions(){

        var scrollElements = $(this.bulb.options.itemsParallaxable);
        var self = this;

        if (scrollElements != null) {
            scrollElements.each(function(elt) {
                var element = $(this);

                if(!Verge.inViewport(element)) return;

                // on va va un decalage de bloc, plus le bloc est bas plus le décallage est grand
                let level = Number(element.attr('data-level'));

                // on va pondérer le décallage en fonction de la taille de l'écran, plus lécran est petit plus le décallage est petit
                level = (Verge.viewportW() / 1920) * level;

                let viewportOffset = element.get(0).getBoundingClientRect();

                let yFromWP = Math.floor(viewportOffset.top) - self.parallaxableResetY;
                let yPercentWP = yFromWP * 100 / self.windowHeight;
                let decalY = Math.floor(yPercentWP * level / 100);
                let offsetY = decalY;

                // pas possible d'aller plus haut que le top pour les elements avec la classe parallaxable__fixeToTop
                if(element.hasClass('parallaxable__fixeToTop') && (self.bulb.device.isLg || self.bulb.device.isXl || element.hasClass('homeBackground')) ){

                    let containerY = Math.abs(Utils.getTranslateY($(self.bulb.options.containerScrollable)));
                    if( containerY  > $(this).data('top') ){
                        decalY = containerY - $(this).data('top');
                    }

                    if(containerY < $(this).data('top') ){
                        decalY = 0;
                        if(offsetY > 0){
                            decalY = offsetY;
                        }
                    }

                }


                decalY = Math.ceil(decalY);


                if(decalY < 0 && !element.hasClass('parallaxable__fixeToTop')) decalY = 0;

                if(decalY >= 0){
                    TweenMax.set(element, {y: decalY});
                }


            });
        }
    }

}


module.exports = SmoothScroll;